export const transactionHistoryMockData = [
  {
    id: 1,
    name: "Online Shopping",
    details: "John Doe",
    amount: 75.25,
    info: "credit",
    timestamp: "2023-09-19T12:30:45Z",
    type: 0,
  },
  {
    id: 2,
    name: "Grocery Purchase",
    details: "Jane Smith",
    amount: 40.0,
    info: "debit",
    timestamp: "2023-09-19T12:30:45Z",
    type: 1,
  },
  {
    id: 3,
    name: "Restaurant Bill",
    details: "Robert Johnson",
    amount: 120.75,
    info: "credit",
    timestamp: "2023-09-19T12:30:45Z",
    type: 2,
  },
  {
    id: 4,
    name: "Gas Station",
    details: "Emily Davis",
    amount: 35.5,
    info: "debit",
    timestamp: "2023-09-19T12:30:45Z",
    type: 0,
  },
  {
    id: 5,
    name: "Online Subscription",
    details: "Alex Brown",
    amount: 15.99,
    info: "credit",
    timestamp: "2023-09-19T12:30:45Z",
    type: 1,
  },
  {
    id: 6,
    name: "Salary Deposit",
    details: "ABC Company",
    amount: 2000.0,
    info: "credit",
    timestamp: "2023-09-18T12:30:45Z",
    type: 0,
  },
  {
    id: 7,
    name: "ATM Withdrawal",
    details: "Michael Wilson",
    amount: 50.0,
    info: "debit",
    timestamp: "2023-09-18T12:30:45Z",
    type: 2,
  },
  {
    id: 8,
    name: "Freelance Payment",
    details: "Eva Garcia",
    amount: 300.0,
    info: "credit",
    timestamp: "2023-09-18T12:30:45Z",
    type: 1,
  },
  {
    id: 9,
    name: "Bonus Payout",
    details: "David Miller",
    amount: 500.0,
    info: "credit",
    timestamp: "2023-09-18T12:30:45Z",
    type: 2,
  },
  {
    id: 10,
    name: "Rent Payment",
    details: "Sarah White",
    amount: 800.0,
    info: "credit",
    timestamp: "2023-09-18T12:30:45Z",
    type: 0,
  },
  {
    id: 11,
    name: "Electronics Purchase",
    details: "Mark Johnson",
    amount: 299.99,
    info: "debit",
    timestamp: "2023-09-17T15:45:30Z",
    type: 0,
  },
  {
    id: 12,
    name: "Coffee Shop",
    details: "Sophia Davis",
    amount: 10.5,
    info: "debit",
    timestamp: "2023-09-17T17:30:15Z",
    type: 1,
  },
  {
    id: 13,
    name: "Car Service",
    details: "Chris Robinson",
    amount: 150.0,
    info: "credit",
    timestamp: "2023-09-16T10:20:00Z",
    type: 2,
  },
  {
    id: 14,
    name: "Bookstore",
    details: "Emma Wilson",
    amount: 25.8,
    info: "debit",
    timestamp: "2023-09-16T14:15:45Z",
    type: 0,
  },
  {
    id: 15,
    name: "Gym Membership",
    details: "Jake Brown",
    amount: 45.0,
    info: "credit",
    timestamp: "2023-09-15T09:40:30Z",
    type: 1,
  },
  {
    id: 16,
    name: "Travel Booking",
    details: "Olivia Smith",
    amount: 500.0,
    info: "debit",
    timestamp: "2023-09-15T14:55:20Z",
    type: 2,
  },
];
